<template>
  <div>
    <van-nav-bar
      title="我的订单"
      left-arrow
      :fixed="true"
      class="my-nav"
      @click-left="$router.back(-1)"
      @click-right="onClickRight"
      :z-index="100"
    >
      <template #right>
        <van-icon name="wap-home-o" size="18" />
      </template>
    </van-nav-bar>
    <div style="margin-top: 50px">
      <van-row style="font-size: 14px">
        <van-tabs v-model="active" swipeable>
          <van-tab
            v-for="(tab, i) in tabs"
            :key="i"
            :title="tab.name"
            :name="tab.value"
            style="min-height: 640px"
          >
            <van-list
                    v-model="loading"
                    :finished="last"
                    finished-text="没有更多了"
                    @load="loadMore"

            >
              <order
                      v-for="(order, index) in orders"
                      :order="order"
                      :key="index"
                      @goPay="goPay"
                      @cancel="cancelOrder"
              ></order>
            </van-list>

          </van-tab>
        </van-tabs>
      </van-row>
    </div>
  </div>
</template>

<script>
  import { cancelOrder, listOrdersStatus, findAllOrders} from "../../api/order";
import { initOrdersNum } from "../../api/order/submit";
import bus from "../../bus";
import order from "../../components/order";

export default {
  data() {
    return {
      active: undefined,
      tabs: [],
      orders:[],
      page:0,
      last:false,
      loading:false,
      loadFlag:true
    };
  },
  components: {
    order,
  },
  methods: {
    onClickRight() {
      this.$router.push({ path: "home"});
    },
    orderDetail(code) {
      this.$router.push({ path: "order-details", query: { code: code } });
    },
    goPay(code) {
      bus.state.orderCodes = [code];
      this.$router.push("pay");
    },
    cancelOrder(orderNo) {
      cancelOrder(
        orderNo,
        () => {
          this.$toast("订单已取消");
          this.loadData();
          initOrdersNum();
        },
        () => {
          this.$toast("取消失败");
        }
      );
    },
    loadTabs() {
      let active = this.$route.query.active;
      this.active = active ? active : undefined;
      listOrdersStatus((d) => {
        this.tabs = d;
      });
    },
    loadData(){
      this.last = false;
      this.orders=[]
      this.page=0;
      this.loadMore()
    },
    loadMore(){
      if(this.loadFlag){
        this.loadFlag=false;
        this.loading=true;
        findAllOrders({status:this.active==0?undefined:this.active, page:this.page}, d=>{
          this.orders.push(...d.content)
          this.last = d.last
          this.loading=false;
          this.loadFlag=true;
        })
        this.page++;
      }
    }
  },
  mounted() {
    this.loadTabs()
  },
  watch: {
    /*$route() {
      let active = this.$route.query.active;
      this.active = active ? active : undefined;
    },*/
    active(){
      this.loadData()
    }
  },
};
</script>

<style lang="less" scoped>
.pay {
  background: #ff3030;
  color: #ffffff;
  /*border-radius: 10px;*/
  margin-top: 3px;
}

.payed {
  color: #ff3030;
}

.buy-again {
  border-color: #ff3030;
  /*border-radius: 10px;*/
  float: right;
  margin-top: 3px;
}
</style>
